import React from "react";
import { useSearchParams } from "react-router-dom";
import Integration from "@/model/interface/Integration";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import GhlSettings from "./GhlSettings";
import IntegrationSyncLog from "../IntegrationSyncLog";
import IntegrationPushQueue from "../IntegrationPushQueue";

const TABS = ["settings", "push-queue", "sync-log"] as const;
type Tab = (typeof TABS)[number];

interface Props {
  integration: Integration;
}

export default function GhlDetail({ integration }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: Tab = TABS.includes(tabParam as Tab) ? (tabParam as Tab) : "settings";

  const setTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <Tabs value={activeTab} onValueChange={setTab}>
      <TabsList>
        <TabsTrigger value="settings">Settings</TabsTrigger>
        <TabsTrigger value="push-queue">Push Queue</TabsTrigger>
        <TabsTrigger value="sync-log">Sync Log</TabsTrigger>
      </TabsList>

      <TabsContent value="settings" className="mt-6">
        <GhlSettings integration={integration} />
      </TabsContent>

      <TabsContent value="push-queue" className="mt-6">
        <IntegrationPushQueue service={integration.service} />
      </TabsContent>

      <TabsContent value="sync-log" className="mt-6">
        <IntegrationSyncLog integrationId={integration.id} />
      </TabsContent>
    </Tabs>
  );
}
